import tw, { styled } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const StyledLinksWrapper = styled.div`
  ${tw`flex flex-col`}
  ${tw`gap-[12px]`}
  ${tw`pb-1`}
`;

export const StyledImage = styled(ImageElement)`
  ${tw`w-full lg:w-[272px]`}
  ${tw`rounded-lg`}
`;

export const StyledSubheadlineWrapper = styled.div`
  ${tw`p-1`}
  ${tw`min-h-[44px]`}
`;

export const StyledSubHeadline = styled.div`
  ${tw`font-poppins lg:font-inter font-semi-bold tracking-extra`};
  ${tw`text-tag-l lg:text-body-xs text-primary-p1 lg:text-secondary-s1`};
  ${tw`pb-1 lg:pb-0`}
  ${tw`border-b lg:border-none border-neutrals-n7`}
`;

export const StyledContentTitle = styled.span`
  ${tw`font-semi-bold`}
  ${tw`text-neutrals-n7`}
`;
